import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { div } from "framer-motion/client";
import ShowsList from "../components/ShowsList";
import HeroCarousel from "../components/HeroCarousel";
import Search from "../components/Search";
import MovieListingPage from "./MovieListingPage";
import LuxuryGrandCinemaz from "../components/WhyGrandCinemaz";
import MembershipPerksCard from "../components/MembershipPerksCard";
import CinemazHero from "../components/CinemazHero";
import BookTicketsButton from "../components/BookTicketsButton";
import Location from "../components/Location";
import PropertyVideo from "../components/PropertyVideo";

const Home = () => {
  const [shows, setShows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchShows();
  }, []);

  const fetchShows = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://apigrand.dodunsoftsolutions.com/api/show"
      );
      setShows(response.data);
      setError("");
    } catch (err) {
      console.error("Error fetching shows:", err);
      setError("Failed to load shows.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <HeroCarousel />
         <PropertyVideo />
      <BookTicketsButton />
      <Location />
      <CinemazHero />

      <MovieListingPage />
      <LuxuryGrandCinemaz />
      <MembershipPerksCard />
    </div>
  );
};

export default Home;
